import { useAppDispatch } from '@core/redux/hooks';
import {
  decreaseLoading,
  increaseLoading,
} from '@features/layout/store/layout.slice';
import { UpsellFlow } from '@models';
import { PageLimitFilter } from '@typings';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useBreadcrumbs } from 'src/features/layout/hooks/useBreadcrumbs';
import { TableUpsellFlowProps } from 'src/features/upsellFunnel/screens/UpsellFunnel/components/upsellFlows/Table.upsellFlows';
import { getAllUpsellFlow as getAllUpsellFlowApi } from 'src/service/api/upsellFlow';

import OpenNotification from '../components/antd/OpenNotification';

const PAGE_SIZE = 20;
export function useUpsellFlows() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [upsellList, setUpsellFlowList] =
    useState<UpsellFlow.TUpsellFlowResponse>();

  const [currentFilter, setCurrentFilter] = useState<PageLimitFilter>();
  const [isLoadingData, setIsLoadingData] = useState(true);

  const [isOpenAddModal, seIsOpenAddModal] = useState(false);

  const getAllUpsellFlow = useCallback(async (props?: PageLimitFilter) => {
    try {
      setIsLoadingData(true);
      dispatch(increaseLoading());
      if (props) setCurrentFilter(props);

      if (!props?.limit || !props.page) {
        props = {
          ...props,
          limit: PAGE_SIZE,
          page: 1,
          order: '[id, DESC]',
        };
      }
      const response = await getAllUpsellFlowApi(props);
      setUpsellFlowList(response);
    } catch (err) {
      console.error(err);
      OpenNotification(true, 'Falha ao carregar os funis do sistema.');
    } finally {
      dispatch(decreaseLoading());
      setIsLoadingData(false);
    }
  }, []);

  const handleOpenAddModal = () => {
    seIsOpenAddModal(true);
  };
  const handleCloseAddModal = () => {
    seIsOpenAddModal(false);
  };
  const handleSuccessAddModal = () => {
    handleCloseAddModal();
    getAllUpsellFlow();
  };

  useEffect(() => {
    getAllUpsellFlow();
  }, []);

  useBreadcrumbs([
    {
      label: 'Upsell',
    },
    {
      label: 'Produtos',
    },
  ]);

  const handleChangePagination: TableUpsellFlowProps['onChangePagination'] = (
    take,
    _,
    pagination
  ) => {
    getAllUpsellFlow({
      ...currentFilter,
      limit: take,
      page: pagination,
      order: '[id, DESC]',
    });
  };

  const handleFilterUpsellFlow = useCallback(
    (filterList: { field: string; value?: string }[]) => {
      const current = {
        ...currentFilter,
        filter: {
          ...currentFilter?.filter,
        },
      };

      filterList.forEach(filterToAdd => {
        if (!filterToAdd.value) {
          delete current.filter?.[filterToAdd.field];
        } else {
          current.filter[filterToAdd.field] = filterToAdd.value;
        }
      });

      getAllUpsellFlow(current as PageLimitFilter);
    },
    [getAllUpsellFlow, currentFilter]
  );

  const handleUpsellFlow = useCallback(
    (order: string) => {
      getAllUpsellFlow({ ...currentFilter, order });
    },
    [getAllUpsellFlow, currentFilter]
  );

  const handleEditUpsellFlow = useCallback(
    (upsellFlow: UpsellFlow.IUpsellFlow) => {
      const queryParams = new URLSearchParams({
        flowId: String(upsellFlow.id),
      });

      navigate(`/upsell/step/flow?${queryParams.toString()}`);
    },
    [navigate]
  );

  return {
    handleChangePagination,
    upsellList,
    isLoadingData,
    handleUpsellFlow,
    handleEditUpsellFlow,
    handleFilterUpsellFlow,
    addModal: {
      isOpenAddModal,
      handleOpenAddModal,
      handleCloseAddModal,
      handleSuccessAddModal,
    },
    pageSize: PAGE_SIZE,
  };
}
